const PASSWORD_SPECIAL_CHAR_PATTERN = /[!@#$%^&*()_+\-=[\]{}|;:'",.<>?/~`]/g;
const PASSWORD_SPECIAL_CHAR_SINGLE = /[!@#$%^&*()_+\-=[\]{}|;:'",.<>?/~`]/;
const DISALLOWED_PASSWORD_CHAR_SINGLE = /[\u00D7\u00F7\u2212]/;
function isPasswordCharsetAllowed(value) {
    for (const char of value) {
        if (DISALLOWED_PASSWORD_CHAR_SINGLE.test(char)) {
            return false;
        }
        if (/[a-zA-Z0-9]/.test(char)) {
            continue;
        }
        if (/[À-ÿ]/.test(char)) {
            continue;
        }
        if (PASSWORD_SPECIAL_CHAR_SINGLE.test(char)) {
            continue;
        }
        return false;
    }
    return true;
}
export function isValidPassword(value) {
    return getPasswordValidationErrorKey(value) === undefined;
}
export function getPasswordValidationErrorKey(value) {
    if (!value || value.length < 8 || value.length > 20) {
        return 'password-invalid';
    }
    if (!isPasswordCharsetAllowed(value)) {
        return 'password-invalid-character';
    }
    if (!/[a-zA-ZÀ-ÿ]/.test(value)) {
        return 'password-invalid';
    }
    if (!/\d/.test(value)) {
        return 'password-invalid';
    }
    const specialChars = value.match(PASSWORD_SPECIAL_CHAR_PATTERN);
    const specialCharsCount = specialChars?.length ?? 0;
    if (specialCharsCount === 0) {
        return 'password-no-special';
    }
    if (specialCharsCount > 1) {
        return 'password-too-many-specials';
    }
    return undefined;
}
export function getResetPasswordValidationErrorKey(value) {
    const errorKey = getPasswordValidationErrorKey(value);
    if (errorKey === undefined) {
        return undefined;
    }
    return `reset-password.${errorKey}`;
}
export function getOnboardingPasswordValidationErrorKey(value) {
    const errorKey = getPasswordValidationErrorKey(value);
    if (errorKey === undefined) {
        return undefined;
    }
    return `onboarding.${errorKey}`;
}
